import { render, staticRenderFns } from "./ExpensesIndicators.vue?vue&type=template&id=e67d68d8&"
import script from "./ExpensesIndicators.vue?vue&type=script&lang=js&"
export * from "./ExpensesIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports